<template lang="pug">
  div.submit(v-if="faqShow")
    van-form(@submit="onSubmit")
        van-field(class="submit_select", :value="type", :placeholder="this.$t('selectQuestionType')", readonly, @click="typeShow = true", :rules="[{required: true, message: this.$t('selectQuestionType')}]")
        //- van-field(v-model="game", placeholder="请选择游戏产品", disabled)
        van-field(v-model="showServerName", :placeholder="this.$t('inputService')", :rules="[{required: true, message: this.$t('inputService')}]")
        van-field(v-model="showRoleName", v-if="appid !== '1017'", :placeholder="this.$t('inputRoll')", :rules="[{required: (appid == '1017' ? false : true), message: this.$t('inputRoll')}]")
        van-field(v-model="phone", type="tel", :placeholder="this.$t('inputTel')", :rules="[{ pattern: /^$|^\\+?\\d+(-)?\\d+$/, message: this.$t('patternTelErr')}]")
        van-field(v-model="email", :placeholder="this.$t('inputEmailSure')", :rules="[{required: true, message: this.$t('inputEmailSure')},{ pattern: /^([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/, message: this.$t('emailPatternErr')}]")
        van-field(v-model="content", rows="3", autosize, type="textarea", maxlength="500", :placeholder="this.$t('inputMsg')", show-word-limit, :rules="[{required: true, message: this.$t('inputMsg')}]")
        van-field(name="uploader", @click="uploadClickHandle")
            template(#input)
                van-uploader(v-model="uploader")
        van-button(type="danger", class="submit_btn", round, :disabled='isDisabled') {{this.$t('submit')}}
        van-popup(v-model="typeShow", position="bottom")
            van-picker(show-toolbar, :columns="columns", @confirm="pickerConfirm", @cancel="typeShow = false", :confirm-button-text="sure", :cancel-button-text="back")
    van-loading(v-if="showLoad===true", color="#E60012", vertical) {{$t('uploading')}}
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import {mapActions, mapGetters} from 'vuex';
import Qs from 'qs';
import { Toast } from 'vant';

export default {
  name: 'Submit',
  data(){
    return{
        typeShow: false,
        type: '',
        typeId: '',
        game: '',
        showServerName: '',
        showRoleName: '',
        phone: '',
        email: '',
        content: '',
        uploader: [],
        updata: [],
        columns: [],
        isDisabled: false,
        showLoad: false,
        faqShow: false
    }
  },
  created(){
  },
  methods:{
    ...mapActions('faq', ['saveUnknownQu', 'getCategoryList', 'getFaqVersion']),
    uploadClickHandle(){
      window.vuplex && window.vuplex.postMessage({type: 'showForegroundWindow', message: '提高弹窗优先级'})
    },
    onSubmit(){
        if(this.showLoad){
          return false
        }
        let items = this.uploader.values();
        console.log(this.uploader);
        this.updata = [];
        for(let item of items){
            this.updata.push(this.dataURLtoFileFun(item.content, item.file.name, item.file.type));
        }
        let count = 0
        this.updata.map(val => {
          count += val.size
        })
        if(count > 104857600){
          Toast({
            message: this.$t('limit10M'),
            type: "fail"
          })
        } else {
          if(!this.isDisabled){
            this.content = this.content.replaceAll('\n','</br>')
            this.showLoad = true
            this.saveUnknownQu({
                uid: this.uid,
                deviceId: this.deviceId,
                accessToken: this.token,
                appId: this.appid,
                sessionName: this.uname,
                email: this.email,
                phone: this.phone,
                type: this.typeId,
                content: this.content,
                serverName: this.showServerName || '',
                roleName: this.showRoleName,
                phoneModel: this.phoneModel,
                files: this.updata
            })  
            this.isDisabled = true
          }
        }
    },

    dataURLtoFileFun (dataurl, filename, type) {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: type });
    },

    pickerConfirm(v){
        this.type = v;
        this.categoryList.faqCategoryList.map(val => {
            if(val.title === this.type){
                this.typeId = val.id
            }
        });
        console.log(this.typeId)
        this.typeShow = false;
    }
  },
  computed:{
    ...mapGetters(['loading', 'uid', 'deviceId', 'token', 'appid', 'uname', 'roleName', 'serverName', 'channelId', 'lang', 'phoneModel']),
    ...mapGetters('faq', ['errmsg', 'loadingCate', 'categoryList', 'statusUnknown', 'unknownStatus', 'faqVersion', 'fvLoading']),
    sure: $vm => {
      return $vm.$t('sure')
    },
    back: $vm => {
      return $vm.$t('return')
    },
  },
  mounted(){
    if(this.appid){
      this.showServerName = this.serverName
      this.showRoleName = this.roleName
      this.getCategoryList(Qs.stringify({
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token,
        appId: this.appid,
        channelId: this.channelId,
        phoneModel: this.phoneModel,
        languageCode: this.lang
      }))
      this.getFaqVersion({
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token,
        appId: this.appid,
      })
    }
    this.$watch('appid', val => {
      this.showServerName = this.serverName
      this.showRoleName = this.roleName
      this.getCategoryList(Qs.stringify({
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token,
        appId: this.appid,
        channelId: this.channelId,
        phoneModel: this.phoneModel,
        languageCode: this.lang
      }))
      this.getFaqVersion({
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token,
        appId: this.appid,
      })
    })
    this.$watch('fvLoading', val => {
      if(val === 'loaded'){
        // window.webkit.messageHandlers.showToastForJS.postMessage(this.faqVersion.extVal)
        if(this.faqVersion.extVal && this.faqVersion.extVal == 'v2'){
          window.location.href = CONFIG.v2faqUrl + '/faq/0'
        } else {
          this.faqShow = true
        }
      }
    })
    this.$watch('loadingCate', (val, oldval) => {
      // console.log(val, oldval)
      if(val === 'loadedCate'){
          this.columns = this.categoryList.faqCategoryList.map(val => {
              if(val.id == this.$route.query.faqCategory){
                this.type = val.title
              }
              return val.title
          });
          console.log(this.columns)
        // console.log(this.categoryList.faqCategoryList)
      }
    })
    this.$watch('statusUnknown', val => {
      if(val === 'statedUnknown'){
        if(this.unknownStatus === 'success'){
          Toast({
            message: this.$t('uploadSuccess'),
            type: 'success',
            onClose: () => {
              typeof(ntAndroidWeb) !== 'undefined' && ntAndroidWeb.webClose() || (window.vuplex && window.vuplex.postMessage({type: 'close', message: '关闭网页'})) || (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.webClose.postMessage(null))
            }
          })
        } else {
          this.showLoad = false
          this.isDisabled = false
        }
      }
    })
  }
}
</script>
<style lang="scss">
.submit{
    color: #c8c9cc;
    margin: 20px;
    .van-loading{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,0.3);
    }
  .van-loading__spinner--circular{
    top: 50%
  }
  .van-loading__text{
    position: relative;
    top: 50%;
    color: #E60012
  }
    .submit_select{
        position: relative;
        .van-field__body{
            &::after {
                position: absolute;
                top: 50%;
                right: -4px;
                margin-top: -5px;
                border: 3px solid;
                border-color: transparent transparent #dcdee0 #dcdee0;
                -webkit-transform: rotate(-45deg);
                transform: rotate(-45deg);
                opacity: 0.8;
                content: '';
            }
        }
    }
    .van-field{
        margin-top: 10px;
        border-radius: 5px;
        box-shadow: 0px 0px 5px 2px #ebebeb;
    }
    .submit_btn{
        margin-top: 10px;
        width: 90%;
        left: 5%;
        padding: 15px;
    }
}
</style>